import { connect } from "react-redux";
import { getListGhiChu } from "actions/ChiTietHopDong";
import GhiChu from "components/CommonComponent/GhiChu";
import {
  postGhiChuChoVay,
  deleteGhiChuChoVay,
  setLoadGhiChu,
} from "actions/GhiChuChoVay";

const mapStateToProps = (state) => ({
  chitiethopdong: state.chitiethopdong,
  ghichuchovay: state.ghichuchovay,
});

const mapDispatchToProps = (dispatch) => ({
  getListGhiChu: (dataSearch) => dispatch(getListGhiChu(dataSearch)),
  postGhiChuChoVay: (dataPost) => dispatch(postGhiChuChoVay(dataPost)),
  deleteGhiChuChoVay: (dataPost) => dispatch(deleteGhiChuChoVay(dataPost)),
  setLoadGhiChu: (dataPost) => dispatch(setLoadGhiChu(dataPost)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GhiChu);
